import request from "@/utils/request";

export function getHistory(hasSchool) {
  return request({
    url: "discussion/get",
    method: "post",
    data: { hasSchool: hasSchool },
  });
}

export function getMembers(fserial) {
  return request({
    url: "discussion/getmembers",
    method: "post",
    data: { Fserial: fserial },
  });
}

export function searchPeople(fserial, hasSchool) {
  return request({
    url: "discussion/searchforadd",
    method: "post",
    data: { Fserial: fserial, hasSchool: hasSchool },
  });
}

export function saveMember(Srl_Discussion_Grp, Srl_Student) {
  return request({
    url: "discussion/savememeber",
    method: "post",
    data: { Srl_Discussion_Grp: Srl_Discussion_Grp, Srl_Student: Srl_Student },
  });
}

export function removeMember(fserial) {
  return request({
    url: "discussion/removemember",
    method: "post",
    data: { Fserial: fserial },
  });
}

export function getStudentSessions(fserial) {
  return request({
    url: "discussion/getsessionsstudent",
    method: "post",
    data: { Fserial: fserial },
  });
}

export function getAdminSessions(fserial) {
  return request({
    url: "discussion/getsessionsadmin",
    method: "post",
    data: { Fserial: fserial },
  });
}

export function saveSession(discussionSession) {
  return request({
    url: "discussion/savesession",
    method: "post",
    data: {
      discussionSession: discussionSession,
    },
  });
}

export function removeSession(fserial) {
  return request({
    url: "discussion/removesession",
    method: "post",
    data: { Fserial: fserial },
  });
}
